export const StorageKeys = {
    VERIFICATION: 'verification_state',
    TOKEN: 'authToken',
    SHARE_TOKEN: 'shareToken',
    VERIFIED_EMAIL: 'verified_email',
  } as const

  export const StorageUtils = {
    setVerificationState: (state: {
      email: string;
      isVerified: boolean;
      timestamp: number;
      token: string;
    }) => {

      localStorage.setItem(StorageKeys.VERIFICATION, JSON.stringify(state))
      localStorage.setItem(StorageKeys.TOKEN, state.token)
      // Persist verified status independently of token expiry
      if (state.isVerified && state.email) {
        localStorage.setItem(StorageKeys.VERIFIED_EMAIL, state.email)
      }
    },

    getVerificationState: () => {
      const state = localStorage.getItem(StorageKeys.VERIFICATION)
      if (!state) {
        // Token session gone — check if user previously verified
        const verifiedEmail = localStorage.getItem(StorageKeys.VERIFIED_EMAIL)
        if (verifiedEmail) {
          return { email: verifiedEmail, isVerified: true, token: '', timestamp: 0 }
        }
        return null
      }

      try {
        const parsedState = JSON.parse(state)
        const isExpired = Date.now() - parsedState.timestamp > 24 * 60 * 60 * 1000
        if (isExpired) {
          localStorage.removeItem(StorageKeys.VERIFICATION)
          localStorage.removeItem(StorageKeys.TOKEN)
          // Token expired, but user already verified — preserve verified status
          if (parsedState.isVerified && parsedState.email) {
            return { email: parsedState.email, isVerified: true, token: '', timestamp: 0 }
          }
          return null
        }

        return parsedState
      } catch {
        return null
      }
    },

    clearVerificationState: () => {
      localStorage.removeItem(StorageKeys.VERIFICATION)
      localStorage.removeItem(StorageKeys.TOKEN)
      localStorage.removeItem(StorageKeys.VERIFIED_EMAIL)
    }
  }